/**
 * @file
 * GilderLehrman Toggle Past Journals behaviors.
 */

import touchClick from "./functions/gli__touchClick";

(($, Drupal, once) => {
  /**
   * Behavior description.
   */
  Drupal.behaviors.togglePastJournals = {
    attach(context) {
      // Browse Journals: Toggle Past Journals
      touchClick("#browse-journals", once,() => {
        if ($(".journal-header", context).hasClass("active")) {
          $(".journal-header .past-journals", context).slideUp();
          $(".journal-header", context).removeClass("active");
        } else {
          $(".journal-header .past-journals", context).slideDown();
          $(".journal-header", context).addClass("active");
        }
      });
    },
  };
})(jQuery, Drupal, once);
